// Site/Partner IRNs are sometimes stored without their leading zeros (e.g.
// "19407" on an older CourseShell record vs. the authoritative "019407" on
// the actual Sites/TpPartners document) — likely from an older import that
// didn't preserve the padding. Compare numerically so a legacy unpadded
// value still resolves correctly instead of silently matching nothing.
export const normalizeIrn = (value) => {
  const str = String(value ?? "").trim();
  return /^\d+$/.test(str) ? String(parseInt(str, 10)) : str;
};
